module.exports = __webpack_public_path__ + "static/media/socialImage@1x.d7732aef.png";